import React, { Dispatch, SetStateAction } from 'react';
import ModalComponent from '../../../components/ModalComponent';
import { Grid2 } from '@mui/material';
import {
  CustomerGenderTypes,
  ICustomerRecognitionProps,
} from '../../../services/Recognition/Customer/types';
import { Controller } from 'react-hook-form';
import TextFieldComponent from '../../../components/TextFieldComponent';
import DatePickerComponent from '../../../components/DatePickerComponent';
import dayjs from 'dayjs';
import DropdownSelectComponent from '../../../components/DropdownSelectComponent';
import CheckboxComponent from '../../../components/CheckboxComponent';
import DateFieldComponent from '../../../components/DateFieldComponent';
import { getCustomerGenderType } from '../../../converters/Recognition/Customer';

interface ICustomerDetailsModalProps {
  selectedRecognition?: ICustomerRecognitionProps;
  isOpen: boolean;
  onClose: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const CustomerDetailsModal = ({
  selectedRecognition,
  isOpen,
  setIsOpen,
  onClose,
}: ICustomerDetailsModalProps) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <ModalComponent
      onClose={handleClose}
      isOpen={isOpen}
      title="Informações do Cliente"
    >
      <Grid2
        container
        direction={{ xs: 'column', lg: 'row' }}
        size={12}
        spacing={{ xs: 0, lg: 3 }}
        justifyContent="center"
        alignItems={{ xs: 'center', lg: 'normal' }}
      >
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TextFieldComponent
            label="Nome"
            type={'text'}
            value={selectedRecognition?.name}
          />
          <TextFieldComponent
            label="CPF"
            type={'text'}
            value={selectedRecognition?.cpf}
            mask={'000.000.000-00'}
          />
          <TextFieldComponent
            label="CNPJ"
            type={'text'}
            value={selectedRecognition?.cnpj || 'Não Informado'}
            mask={selectedRecognition?.cnpj ? '00.000.000/0000-00' : ''}
          />
          <DateFieldComponent
            label="Validade da Face"
            value={dayjs(selectedRecognition?.validUntil)}
            format={'DD/MM/YYYY'}
            readOnly={true}
          />
          <TextFieldComponent
            label="Gênero"
            type={'text'}
            value={getCustomerGenderType(
              selectedRecognition?.gender || CustomerGenderTypes.OTHER,
            )}
          />
        </Grid2>
        <Grid2
          size={{ xs: 12, lg: 6 }}
          display={'column'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <TextFieldComponent
            label="Idade"
            type={'text'}
            value={selectedRecognition?.age || 'Não Informado'}
          />
          <DateFieldComponent
            label="Data de Aniversário"
            value={dayjs(selectedRecognition?.birthDate)}
            format={'DD/MM/YYYY'}
            readOnly={true}
          />
          <TextFieldComponent
            label="Celular"
            type={'text'}
            value={selectedRecognition?.phone || 'Não Informado'}
            mask={selectedRecognition?.phone ? '(00) 0 0000-0000' : ''}
          />
          <TextFieldComponent
            label="E-mail"
            type={'text'}
            value={selectedRecognition?.email || 'Não Informado'}
          />
          <TextFieldComponent
            label="Ocupação"
            type={'text'}
            value={selectedRecognition?.occupation || 'Não Informado'}
          />
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default CustomerDetailsModal;
